export default function recaptcha() {
    if (document.querySelector('input#recaptcha-token')) {
        const token = document.querySelector('input#recaptcha-token').value
        return grecaptcha.execute(token, {action: 'submit'})
    } else {
        throw new Error('Recaptcha token not found');
    }
}